/**
 * A helper function to handle the lifecycle of an async thunk.
 * 
 * @param {Object} builder - The builder object from `createReducer`.
 * @param {Object} thunk - An async thunk created by `createAsyncThunk`.
 * @param {string} dataKey - The key to store the data in the state. (example data, userId, etc.)
 * @param {string} errorDataKey - The key to store the error data in the state.
 */

const handleAsyncThunk = (builder, thunk, dataKey, errorDataKey="", loadingDataKey="isLoading") => {  
    builder
        .addCase(thunk.pending, (state) => {
            state[loadingDataKey] = true;
            state[errorDataKey] = null;
        })
        .addCase(thunk.fulfilled, (state, action) => {
            state[dataKey] = action.payload; // setting default Key
            state[errorDataKey] = null; // setting error-key
            state.error = null;
            state.isSession = true;
            state[loadingDataKey] = false;
        })
        .addCase(thunk.rejected, (state, action) => {
            state.error = action.error.message;
            state[errorDataKey] = action.payload;
            state[loadingDataKey] = false;
        })
};

export default handleAsyncThunk;